export default __webpack_public_path__ + "static/media/logo.ceeb5cf5.svg";